import type { SchoolUpdateValuesArray, SchoolUpdateTableValuesArray } from '@/types/view'
import type { DailyRecordApiDto } from '@/types/api/tank.api'
import { getData, postData } from '../../utils'
import { reloadGroupsWithSchoolsAndTanks } from '../../utils/loadStorage'
import { SchoolState } from '../../store/school/useSchoolStore'
import { toast } from '@/utils/toast'

// Helper to convert YYYYMMDD number to YYYY-MM-DD string
const formatDate = (dateNum: number): string => {
  const dateStr = String(dateNum)
  const year = dateStr.substring(0, 4)
  const month = dateStr.substring(4, 6)
  const day = dateStr.substring(6, 8)
  return `${year}-${month}-${day}`
}

/**
 * @deprecated Use fetchUpdateData from @/api/home/home.service instead
 */
export const getUpdate = async (
  tankIds: string[],
  updateDate: number,
  schoolList: SchoolState,
  setSchoolValues: (values: SchoolUpdateValuesArray, schoolList: SchoolState) => void,
  onClose: () => void,
  onOpen: () => void,
) => {
  await getData<DailyRecordApiDto[]>(
    `/tank/daily-records?${tankIds.map((item) => `tank_ids=${item}`).join('&')}&date=${formatDate(updateDate)}`,
  )
    .then((response) => {
      // Transform API response (snake_case) to view type (camelCase)
      // Use ?? null to handle undefined values and prevent NaN
      const transformedResponse: SchoolUpdateValuesArray = response.map((item) => ({
        schoolId: item.tank_id,  // tankId를 임시로 schoolId 위치에 저장 (store에서 매핑)
        nh3: item.nh3 ?? null,
        no2: item.no2 ?? null,
        sampleWeight: item.sample_weight ?? null,
        mortality: item.mortality_count ?? null,
        harvest: item.harvest_count ?? null,
        feedingAmount: null,
        feedTimes: null,
      }))
      setSchoolValues(transformedResponse, schoolList)
      onClose()
      onOpen()
    })
    .catch(() => {
      console.log('Update API Error')
      toast.error('ERROR!')
    })
}

/**
 * @deprecated Use submitUpdate from @/api/home/home.service instead
 */
export const patchUpdate = async (
  updateDate: number,
  updateForm: SchoolUpdateTableValuesArray,
  schoolIds: string[],
  onClose: () => void,
) => {
  // Transform to new v2 API format
  const list = updateForm.map((item) => ({
    tank_id: item.tankId,
    date: formatDate(updateDate),
    nh3: item.nh3 || 0,
    no2: item.no2 || 0,
    sample_weight: item.sampleWeight || 0,
    stock_count: 0,
    mortality_count: item.mortality || 0,
    harvest_count: item.harvest || 0,
    manual_amount: item.feedingAmount || 0,
    manual_count: item.feedTimes || 0,
  }))

  await postData<string[]>(`/tank/daily-records`, { list })
    .then(() => {
      reloadGroupsWithSchoolsAndTanks()
      onClose()
    })
    .catch(() => {
      console.log('Update API Error')
      toast.error('ERROR!!')
    })
}
